import { z } from 'zod';
import { AutonomousCommunitySchema } from './litigation';
import { RoleSchema } from './auth';
export const FirmSchema = z.object({
    id: z.string(),
    name: z.string(),
    legalName: z.string().nullable(),
    cif: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    postalCode: z.string().nullable(),
    province: z.string().nullable(),
    country: z.string(),
    vatRate: z.number(),
    irpfRate: z.number(),
    invoicePrefix: z.string(),
    nextInvoiceNumber: z.number().int(),
    invoiceFootnote: z.string().nullable(),
    bankIban: z.string().nullable(),
    bankBic: z.string().nullable(),
    autonomousCommunity: AutonomousCommunitySchema.nullable(),
    defaultHourlyRateCents: z.number().int().nonnegative(),
    // F14/F15: políticas de seguridad
    enforceMfaRoles: z.array(RoleSchema),
    sessionIdleMinutes: z.number().int().min(5).max(720),
    sessionAbsoluteHours: z.number().int().min(1).max(168),
});
export const UpdateFirmSchema = z.object({
    name: z.string().min(2).max(200).optional(),
    legalName: z.string().max(300).nullable().optional(),
    cif: z.string().max(20).nullable().optional(),
    email: z
        .union([z.string().email(), z.literal('')])
        .nullable()
        .optional(),
    phone: z.string().max(30).nullable().optional(),
    address: z.string().max(300).nullable().optional(),
    city: z.string().max(100).nullable().optional(),
    postalCode: z.string().max(10).nullable().optional(),
    province: z.string().max(100).nullable().optional(),
    country: z.string().length(2).optional(),
    vatRate: z.number().min(0).max(100).optional(),
    irpfRate: z.number().min(0).max(100).optional(),
    invoicePrefix: z.string().max(10).optional(),
    invoiceFootnote: z.string().max(1000).nullable().optional(),
    bankIban: z.string().max(40).nullable().optional(),
    bankBic: z.string().max(20).nullable().optional(),
    autonomousCommunity: AutonomousCommunitySchema.nullable().optional(),
    defaultHourlyRateCents: z.number().int().nonnegative().optional(),
    // F15.3 — políticas de seguridad
    enforceMfaRoles: z.array(RoleSchema).optional(),
    sessionIdleMinutes: z.number().int().min(5).max(720).optional(),
    sessionAbsoluteHours: z.number().int().min(1).max(168).optional(),
});
export const UpdateProfileSchema = z.object({
    fullName: z.string().min(2).max(200),
});
//# sourceMappingURL=firm.js.map